import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ThemeProvider } from '@material-ui/core/styles'
import { Box, Select, MenuItem, Container, Grid, Paper} from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Cancel from '@material-ui/icons/Cancel'
import CircularProgress from '@material-ui/core/CircularProgress'
import Moment from 'react-moment'
import { withStyles } from '@material-ui/core/styles'

import BudgetSubscribersTabComponent from './BudgetSubscribersTabComponent'
import Spinner from '../../components/Spinner'
import NotFound from '../NotFound'
import { BUDGET_SUBSCRIBERS_MODULE, SUBSCRIPTION_OPTIONS, SUBSCRIPTION_NOTES } from '../../constants/commons'

import { styles } from '../../classes/Styles'
import { theme } from '../../classes/Themes'
import './BudgetSubscribersComponent.scss'
import BudgetSubscribersOnBoarding from './BudgetSubscribersOnBoarding'

export class BudgetSubscribersComponent extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    homepage: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string,
      metric_date: PropTypes.string
    }),
    budgetSubscribers: PropTypes.object,
    budgetSubscribersQuarters: PropTypes.object,
    setSelectedMetricDate: PropTypes.func,
    selectedMetricDate: PropTypes.string,
    fetchBudgetSubscribers: PropTypes.func,
    fetchBudgetSubscribersExport: PropTypes.func,
    budgetSubscribersExport: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      selectedSubscriptionType: BUDGET_SUBSCRIBERS_MODULE,
      budgetSubscribers: [],
      exportCompleted: false
    }
    this.scrollRef = React.createRef()
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    if (this.props.homepage && this.props.homepage.details) {
      this.updateDimensions()
    }
    if (this.props.budgetSubscribers.details) {
      this.setState({ budgetSubscribers: this.props.budgetSubscribers.details.budget_subscribers })
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.homepage !== this.props.homepage && this.props.homepage.details) {
      this.updateDimensions()
    }
    if (prevProps.budgetSubscribers !== this.props.budgetSubscribers && this.props.budgetSubscribers.details) {
      this.setState({ budgetSubscribers: this.props.budgetSubscribers.details.budget_subscribers })
    }
    if (this.props.budgetSubscribersExport && !this.props.budgetSubscribersExport.isFetching && prevProps.budgetSubscribersExport.isFetching!=this.props.budgetSubscribersExport.isFetching){
      this.setState({ exportCompleted: true })
      setTimeout(() => {
        this.setState({ exportCompleted: false })
      }, 3000)
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
  }

  setSelectedSubscription = (subscriptionType) => {
    this.setState({
      selectedSubscriptionType: subscriptionType
    })
  }

  handleQuarterChange = (event) => {
    if (!this.props.shortcut) {
      this.props.setSelectedMetricDate(event.target.value)
      this.props.fetchBudgetSubscribers(event.target.value)
    }
  }

  downloadData = () => {
    if (!this.props.shortcut) {
      this.props.fetchBudgetSubscribersExport()
    }
  }

  renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for Budget & Subscribers will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }

    return (
      <BudgetSubscribersOnBoarding
        name={'Budget & Subscribers'}
        run={true}
      />
    )
  }

  render () {
    if ((this.props.homepage && this.props.homepage.isFetching)) {
      return (<Spinner />)
    }
    if (this.props.homepage && this.props.homepage.details && !this.props.homepage.details.is_budget_subscribers) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }
    const { classes } = this.props
    const quarters = this.props.budgetSubscribersQuarters && this.props.budgetSubscribersQuarters.details && this.props.budgetSubscribersQuarters.details.quarters ? this.props.budgetSubscribersQuarters.details.quarters : []

    return (
      <ThemeProvider theme={theme}>
        <Box className="rightSide budgetSubComponent" ref={this.scrollRef}>
          <Container maxWidth="xl" className={classes.containerRootBudgetSubscriber}>
            {this.renderShortcut()}
            {this.renderOnboarding()}
            <Row className="header budgetSubHeader">
              <Col>
                <ul className="hFirstRow">
                  <li className="imgHolder">
                    <img alt="" src="/static/images/budget.svg" className="imgThumb" />
                  </li>
                  <li>
                    <h2 className="title">Budget & Subscribers</h2>
                  </li>
                </ul>
              </Col>
            </Row>
            <div>
              <Row>
                <Col>
                  <Box className="productSelect">
                    <BudgetSubscribersTabComponent
                      screenWidth={this.state.screenWidth}
                      selectedSubscriptionType={this.state.selectedSubscriptionType}
                      setSelectedSubscription={this.setSelectedSubscription}
                      setSelectedNetwork={this.setSelectedNetwork}
                    />
                    <Box className='actionGroup' id='actionGroup'>
                      {/* {this.props.budgetSubscribersExport && this.props.budgetSubscribersExport.isFetching ? <CircularProgress/> :
                      <Box className={this.props.shortcut ? 'downloadBtn disabled' : 'downloadBtn' } onClick={this.downloadData}>
                        <img src="/static/images/export_grey.png" />
                      </Box>} */}
                      <Box onClick={this.downloadData} className={`${this.state.exportCompleted ?'export-completed' : `${this.props.budgetSubscribersExport && this.props.budgetSubscribersExport.isFetching ? 'export-icon-fetching' : 'export-icon'}`}`}>
                        {this.props?.budgetSubscribersExport?.isFetching && <CircularProgress/> }
                      </Box>
                      <Select
                        labelId="select-filled-label"
                        id="select-filled"
                        className={ this.props.shortcut ? 'metricsSelect disabled' : 'metricsSelect' }
                        value={this.props.selectedMetricDate}
                        onChange={(e) => this.handleQuarterChange(e)}
                      >
                        { quarters.length > 0 && quarters.map(quarter => (
                          <MenuItem key={quarter.quarter} value={quarter.metric_date} className={ this.props.shortcut ? 'disabled' : '' }>
                            <Box className="d-flex flex-column pt-1">
                              <span className="optionLabel">
                                { quarter.quarter }
                              </span>
                            </Box>
                          </MenuItem>
                        ))
                        }
                      </Select>
                    </Box>
                  </Box>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Box className="budgetPadding">
                    <Grid container spacing={1}>
                      <Grid item xs={12} lg={12} md={12} sm={12}
                        style={{transition: theme.transitions.create('all', {
                          easing: theme.transitions.easing.sharp,
                          duration: theme.transitions.duration.leavingScreen
                      })}}>
                        <Paper className="cardBase p-b-0">
                          <Grid container direction="column">
                            <Grid item className='cardPadding'>
                              <span className="cardTitle">{this.state.selectedSubscriptionType}</span>
                              <OverlayTrigger overlay={<Tooltip id="tooltip">{this.state.selectedSubscriptionType}</Tooltip>} placement="right">
                                <img src="/static/images/info.png" alt="info" className="cardInfo" />
                              </OverlayTrigger>
                            </Grid>
                            { ((this.props.budgetSubscribersQuarters && !this.props.budgetSubscribersQuarters.error) && this.props.budgetSubscribers && this.props.budgetSubscribers.isFetching) &&
                            <div className='loadingProgress'>
                              <CircularProgress />
                            </div>
                            }
                            { (this.props.budgetSubscribersQuarters && this.props.budgetSubscribersQuarters.error && quarters.length === 0) &&
                              <div className='noData'> No data found</div>
                            }
                            { (this.props.budgetSubscribers && this.props.budgetSubscribers.details && this.state.selectedSubscriptionType === BUDGET_SUBSCRIBERS_MODULE) &&
                              <BudgetSubscribers details={this.state.budgetSubscribers} />
                            }
                            { (this.props.budgetSubscribers && this.props.budgetSubscribers.details && this.state.selectedSubscriptionType === SUBSCRIPTION_OPTIONS) &&
                              <SubscriptionOptions details={this.state.budgetSubscribers} />
                            }
                            { (this.props.budgetSubscribers && this.props.budgetSubscribers.details && this.state.selectedSubscriptionType === SUBSCRIPTION_NOTES) &&
                              <SubscriptionNotes details={this.state.budgetSubscribers} />
                            }
                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </Col>
              </Row>
            </div>
          </Container>
        </Box>
      </ThemeProvider>
    )
  }
}

export class BudgetSubscribers extends React.Component {
  static propTypes = {
    details: PropTypes.array.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      order: 'asc',
      orderBy: 'network'
    }
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    })
  }

  createData = (id, network, parentCompany, global, domestic, parentD2CGlobal, budgetParentCompany, budgetNetwork, globalSubscriberCountSource, contentBudgetSource, globalNum, domesticNum, parentD2CGlobalNum, budgetParentCompanyNum, budgetNetworkNum) => {
    return { id, network, parentCompany, global, domestic, parentD2CGlobal, budgetParentCompany, budgetNetwork, globalSubscriberCountSource, contentBudgetSource, globalNum, domesticNum, parentD2CGlobalNum, budgetParentCompanyNum, budgetNetworkNum }
  }

  render () {
    let rows = this.props.details
    rows = rows.filter(r => !r.data.data.networkId)
    rows = rows.map(row => this.createData(row.id, row.data.data.network, row.data.data.parentCompany, row.data.data.global, row.data.data.domestic, row.data.data.parentD2CGlobal, row.data.data.budgetParentCompany, row.data.data.budgetNetwork, row.data.data.globalSubscriberCountSource, row.data.data.contentBudgetSource, row.data.data.global === '-' ? 0 : Number(row.data.data.global.replace(',', '')), row.data.data.domestic === '-' ? 0 : Number(row.data.data.domestic.replace(',', '')), row.data.data.parentD2CGlobal === '-' ? 0 : Number(row.data.data.parentD2CGlobal.replace(',', '')), row.data.data.budgetParentCompany === 'n/a' ? 0 : Number(row.data.data.budgetParentCompany.replace('$', '').replace(',', '')), row.data.data.budgetNetwork === 'n/a' ? 0 : Number(row.data.data.budgetNetwork.replace('$', '').replace(',', ''))))

    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    let resultRows = this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy))
    return (
      <>
        <TableContainer className="mt-2 budgetSubTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan="2"></StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell colSpan="3" align='center'>Subscribers (M)</StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell colSpan="2" align='center'>Annual Content Budget ($B)</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'network'}
                    direction={this.state.orderBy === 'network' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('network')}
                  >
                    Network
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'parentCompany'}
                    direction={this.state.orderBy === 'parentCompany' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('parentCompany')}
                  >
                    Parent
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={this.state.orderBy === 'globalNum'}
                    direction={this.state.orderBy === 'globalNum' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('globalNum')}
                  >
                    Global
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={this.state.orderBy === 'domesticNum'}
                    direction={this.state.orderBy === 'domesticNum' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('domesticNum')}
                  >
                    Domestic
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align='center' className='subParent'>
                  <TableSortLabel
                    active={this.state.orderBy === 'parentD2CGlobalNum'}
                    direction={this.state.orderBy === 'parentD2CGlobalNum' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('parentD2CGlobalNum')}
                  >
                    Parent D2C (Global)
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={this.state.orderBy === 'budgetParentCompanyNum'}
                    direction={this.state.orderBy === 'budgetParentCompanyNum' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('budgetParentCompanyNum')}
                  >
                    Parent
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={this.state.orderBy === 'budgetNetworkNum'}
                    direction={this.state.orderBy === 'budgetNetworkNum' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('budgetNetworkNum')}
                  >
                    Network
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { resultRows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.network}</TableCell>
                  <TableCell>{row.parentCompany}</TableCell>
                  <TableCell className='tableSpace' width="6"></TableCell>
                  <TableCell align='center'><a href={row.globalSubscriberCountSource ? row.globalSubscriberCountSource : '#'} target={row.globalSubscriberCountSource ? '_blank' : '_self'} rel="noopener noreferrer">{row.global}</a></TableCell>
                  <TableCell align='center'>{row.domestic}<sup></sup></TableCell>
                  <TableCell align='center'><a href="#" className='subParent'>{row.parentD2CGlobal}</a></TableCell>
                  <TableCell className='tableSpace' width="6"></TableCell>
                  <TableCell align='center'><a href={row.contentBudgetSource ? row.contentBudgetSource : '#'} target={row.contentBudgetSource ? '_blank' : '_self'} rel="noopener noreferrer">{row.budgetParentCompany}</a></TableCell>
                  <TableCell align='center'>{row.budgetNetwork}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}

export class SubscriptionOptions extends React.Component {
  static propTypes = {
    details: PropTypes.array.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      order: 'asc',
      orderBy: 'network'
    }
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    })
  }

  createData = (id, network, parentCompany, global, subscriptionOptionsFree, subscriptionOptionsPaidWithAds, subscriptionOptionsPaidWithoutAds, bundle, globalSubscriberCountSource, pricingSource ) => {
    return { id, network, parentCompany, global, subscriptionOptionsFree, subscriptionOptionsPaidWithAds, subscriptionOptionsPaidWithoutAds, bundle, globalSubscriberCountSource, pricingSource }
  }

  render () {
    let rows = this.props.details
    rows = rows.filter(r => !r.data.data.networkId)

    rows = rows.map(row => this.createData(row.id, row.data.data.network, row.data.data.parentCompany, row.data.data.global, row.data.data.subscriptionOptionsFree, row.data.data.subscriptionOptionsPaidWithAds, row.data.data.subscriptionOptionsPaidWithoutAds, row.data.data.bundle, row.data.data.globalSubscriberCountSource, row.data.data.pricingSource))

    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    let resultRows = this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy))
    return (
      <>
        <TableContainer className="mt-2 budgetSubTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan="2"></StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell align='center' className='cellGlobal'>Subscribers (M)</StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell colSpan="4" align='center'>Subscription options</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'network'}
                    direction={this.state.orderBy === 'network' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('network')}
                  >
                    Network
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'parentCompany'}
                    direction={this.state.orderBy === 'parentCompany' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('parentCompany')}
                  >
                    Parent
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell align='center' className='cellGlobal'>Global-Insights Compare View</StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell align='center'>Free (w/ads)</StyledTableCell>
                <StyledTableCell align='center'>Paid (w/ads)</StyledTableCell>
                <StyledTableCell align='center' className='planWidth'>Paid (w/o ads)</StyledTableCell>
                <StyledTableCell align='center'>Bundle</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {resultRows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.network}</TableCell>
                  <TableCell>{row.parentCompany}</TableCell>
                  <TableCell className='tableSpace' width="6"></TableCell>
                  <TableCell align='center' className='cellGlobal'><a href={row.globalSubscriberCountSource ? row.globalSubscriberCountSource : '#'} target={row.globalSubscriberCountSource ? '_blank' : '_self'} rel="noopener noreferrer">{row.global}</a></TableCell>
                  <TableCell className='tableSpace' width="6"></TableCell>
                  <TableCell align='center'>{row.subscriptionOptionsFree}</TableCell>
                  <TableCell align='center'>
                    {row.subscriptionOptionsPaidWithAds}
                  </TableCell>
                  <TableCell align='center' className='planWidth'>
                    { row.subscriptionOptionsPaidWithoutAds.indexOf('\n') > -1 &&
                      <a href={row.pricingSource ? row.pricingSource : '#'} target={row.pricingSource ? '_blank' : '_self'} rel="noopener noreferrer">
                        {
                          row.subscriptionOptionsPaidWithoutAds.split('\n').map((sub, i) => {
                            return (<div key={`${row.id}_${i}`}>{sub}</div>)
                          })
                        }
                      </a>
                    }
                    { row.subscriptionOptionsPaidWithoutAds.indexOf('\n') === -1 &&
                      <a href={row.pricingSource ? row.pricingSource : '#'} target={row.pricingSource ? '_blank' : '_self'} rel="noopener noreferrer">{row.subscriptionOptionsPaidWithoutAds}</a>
                    }
                  </TableCell>
                  <TableCell align='center'>{row.bundle}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}

export class SubscriptionNotes extends React.Component {
  static propTypes = {
    details: PropTypes.array.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      order: 'asc',
      orderBy: 'network'
    }
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    })
  }

  createData = (id, network, parentCompany, notes ) => {
    return { id, network, parentCompany, notes }
  }

  render () {
    let rows = this.props.details
    rows = rows.filter(r => !r.data.data.networkId)
    rows = rows.map(row => this.createData(row.id, row.data.data.network, row.data.data.parentCompany, row.data.data.notes))

    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    let resultRows = this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy))
    return (
      <>
        <TableContainer className="mt-2 budgetSubTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan="2"></StyledTableCell>
                <StyledTableCell className='tableSpace' width="6"></StyledTableCell>
                <StyledTableCell colSpan="1"></StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'network'}
                    direction={this.state.orderBy === 'network' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('network')}
                  >
                    Network
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === 'parentCompany'}
                    direction={this.state.orderBy === 'parentCompany' ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler('parentCompany')}
                  >
                    Parent
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell className='notesTableSpace' width="12"></StyledTableCell>
                <StyledTableCell align='center' className='notesCell'>Notes</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {resultRows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.network}</TableCell>
                  <TableCell>{row.parentCompany}</TableCell>
                  <TableCell className='notesTableSpace' width="12"></TableCell>
                  <TableCell align='center' className='notesCell'>{row.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}

export default withStyles(styles)(BudgetSubscribersComponent)
